module.exports = __webpack_public_path__ + "img/e3.14228d8d.jpeg";